import { createFileRoute } from '@tanstack/react-router'
import AddPlanForm from '@/features/plans/components/AddPlanForm'

export const Route = createFileRoute('/_authed/plans/new')({
  component: AddPlanForm,
})
